import { tracking } from '@bark/bark-core';

/**
 * Project Details component on Lead details
 */

export const shouldShowProjectDetailsLeadDetailsRct = () =>
	$('#__rctProjectDetailsLeadDetails').length && window?.SellerAppDashboard;

export const isProjectDetailsLeadDetailsRctLoaded = () =>
	$(`#__rctProjectDetailsLeadDetails`).children().length;

export let ProjectDetailsLeadDetailsRctDispatcher = null;

export function loadProjectDetailsLeadDetailsRct(project) {
	if (!isProjectDetailsLeadDetailsRctLoaded()) {
		window.SellerAppDashboard.launchModule(
			'project-details-lead-details',
			'__rctProjectDetailsLeadDetails',
			{
				onMount: (dispatch) => {
					ProjectDetailsLeadDetailsRctDispatcher = dispatch;
					setProjectDetailsLeadDetailsRctState(project);
				},
			},
		);
	} else {
		setProjectDetailsLeadDetailsRctState(project);
	}
}

export function setProjectDetailsLeadDetailsRctState(project) {
	if (ProjectDetailsLeadDetailsRctDispatcher) {
		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setBuyerShareName',
			value: project.buyer_share_name,
		});

		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setBgColor',
			value: project.bg_color,
		});

		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setCityString',
			value: project.city_string,
		});

		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setIsLocal',
			value: project.is_local,
		});

		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setIsRemoteSupported',
			value: project.is_remote_supported,
		});

		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setTimeSince',
			value: project.time_since,
		});

		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setSince',
			value: project.since,
		});

		ProjectDetailsLeadDetailsRctDispatcher({
			type: 'setProjectTitle',
			value: project.project_title,
		});
	}
}

/**
 * Responses component on Lead details
 */

export const shouldShowResponsesLeadDetailsRct = () =>
	$('#__rctResponsesLeadDetails').length && window?.SellerAppDashboard;

export const isResponsesLeadDetailsRctLoaded = () =>
	$(`#__rctResponsesLeadDetails`).children().length;

export const shouldShowBookingDetailsRct = () =>
	$(`#__rctProjectDetailsBookingDetails`).length && window?.SellerAppDashboard;

export let ResponsesLeadDetailsRctDispatcher = null;

export function loadResponsesLeadDetailsRct(project) {
	if (!isResponsesLeadDetailsRctLoaded()) {
		window.SellerAppDashboard.launchModule(
			'lead-details-responses',
			'__rctResponsesLeadDetails',
			{
				onMount: (dispatch) => {
					ResponsesLeadDetailsRctDispatcher = dispatch;
					setResponsesLeadDetailsRctState(project);
				},
			},
		);
	} else {
		setResponsesLeadDetailsRctState(project);
	}
}

export function setResponsesLeadDetailsRctState(project) {
	if (ResponsesLeadDetailsRctDispatcher) {
		ResponsesLeadDetailsRctDispatcher({
			type: 'setResponseCap',
			value: project.response_cap,
		});

		ResponsesLeadDetailsRctDispatcher({
			type: 'setResponseCount',
			value: project.response_count,
		});
	}
}

/**
 * Buyer interaction on Lead details
 */

export const shouldShowBuyerInteractionLeadDetailsRct = () =>
	$('#__rctBuyerInteractionLeadDetails').length && window?.SellerAppDashboard;

let buyerInteractionLeadDetailsRctLoaded = false;

export const isBuyerInteractionLeadDetailsRctLoaded = () =>
	buyerInteractionLeadDetailsRctLoaded;

export let BuyerInteractionLeadDetailsRctDispatcher = null;

export function loadBuyerInteractionLeadDetailsRct(project) {
	if (!isBuyerInteractionLeadDetailsRctLoaded()) {
		window.SellerAppDashboard.launchModule(
			'lead-details-buyer-interaction',
			'__rctBuyerInteractionLeadDetails',
			{
				onMount: (dispatch) => {
					BuyerInteractionLeadDetailsRctDispatcher = dispatch;
					setBuyerInteractionLeadDetailsRctState(project);
				},
			},
		);
		buyerInteractionLeadDetailsRctLoaded = true;
	} else {
		setBuyerInteractionLeadDetailsRctState(project);
	}
}

export function setBuyerInteractionLeadDetailsRctState(project) {
	if (BuyerInteractionLeadDetailsRctDispatcher) {
		BuyerInteractionLeadDetailsRctDispatcher({
			type: 'setHighlights',
			value: project.highlights,
		});

		BuyerInteractionLeadDetailsRctDispatcher({
			type: 'setBuyerName',
			value: project.buyer_share_name,
		});

		BuyerInteractionLeadDetailsRctDispatcher({
			type: 'setBuyerInteractionMeta',
			value: { buyerMessages: project.buyer_messages, avatarColor: project.bg_color },
		});
	}
}

const showModalQueryKey = 'brlm';
// Show setup jobs modal
export function showSetupJobsModal(trackingEntity) {
	const url = new URLSearchParams(window.location.search);

	if (url.get(showModalQueryKey) === '1') {
		url.delete(showModalQueryKey);
		window.SellerAppDashboard.launchModule(
			'booking-request-landing-modal',
			'__rctBookingRequestLandingModal',
			{
				isOpen: true,
				tracking: trackingEntity,
			},
		);
	}
}

const showBookingRequestOnboardingModalQueryKey = 'brom';
// Show booking request onboarding modal
export function showBookingRequestOnboardingModal(trackingEntity) {
	const url = new URLSearchParams(window.location.search);

	if (url.get(showBookingRequestOnboardingModalQueryKey) === '1') {
		url.delete(showBookingRequestOnboardingModalQueryKey);
		window.SellerAppDashboard.launchModule(
			'booking-request-onboarding-tour-modal',
			'__rctBookingRequestOnboardingTourLandingModal',
			{
				isOpen: true,
				tracking: trackingEntity,
			},
		);
	}
}
